import { render } from "./DeleteGlobalPriceConfirmationModal.vue?vue&type=template&id=731ec125&ts=true"
import script from "./DeleteGlobalPriceConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteGlobalPriceConfirmationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__